import React, { useState } from 'react'
import expandLogo from '../../../assets/images/Expand Arrow copy.png';

const TransferTypeSB = (props) => {

    let { transferFrom, setTransferFrom, selectFrom, transferFromData, setExpandFrom, expandFrom } = props;

    const [search, setSearch] = useState('');

    const suggestions = transferFromData && transferFromData.filter((data) => {
        return data.agentName.toLowerCase().includes(search.toLowerCase())
    });

    const handleClick = (transferFrom) => {
        setTransferFrom(transferFrom);
        setSearch(transferFrom.agentName);
        setExpandFrom(false);
    }

    const handleOnChange = (e) => {
        setSearch(e.target.value);
    };

    return (
            <div className='flex z-30 relative w-full'>
                <div className={`bg-bgColor text-fgColor px-2 py-2 w-full flex items-center justify-between rounded-sm cursor-pointer shadow-lg `}
                onClick={(e) => selectFrom(e)}>
                        
                    <input 
                        type="text" 
                        className='bg-bgColor outline-none' 
                        value={search} 
                        onChange={handleOnChange} 
                        placeholder={transferFrom.agentName}
                    />

                    <img src={expandLogo} alt="X" className='-ml-5 w-6' onClick={()=>setSearch('')} />
                </div>
                {
                    expandFrom ?
                        <div className="bg-bgColor text-fgColor w-full absolute top-[45px] cursor-pointer overflow-auto h-[210px] shadow-lg ">
                            {
                                suggestions && suggestions.map((suggestion, index) => (
                                    <div key={index}
                                        className={`${suggestion.agentId !== suggestion.length ? "border-b" : "border-b-0"}  py-2
                                        px-4 hover:bg-primary hover:text-rectangle  transition-all duration-100 `}
                                        onClick={()=>handleClick(suggestion)}
                                    >
                                        {suggestion.agentName}
                                    </div>
                                ))
                            }
                        </div> : ""
                }
                
            </div>
        )
}

export default TransferTypeSB